/* eslint-disable import/no-anonymous-default-export */
import { SupplierList } from './SupplierList';
import { SupplierCreate } from './SupplierCreate';
import { SupplierShow } from './SupplierShow';
import { SupplierEdit } from './SupplierEdit';

export default {
    list: SupplierList,
    create: SupplierCreate,
    edit: SupplierEdit,
    show: SupplierShow,
};
